import React, {Component} from "react"
import {Entity} from "aframe-react"

import Helvetica from "../assets/fonts/helveticaNeue.fnt"
import HelveticaSheet from "../assets/fonts/helveticaNeue.png"

import OpenSans from "../assets/fonts/opensans.fnt"
import OpenSansSheet from "../assets/fonts/opensans.png"

import OpenSansBold from "../assets/fonts/opensansbold.fnt"
import OpenSansBoldSheet from "../assets/fonts/opensansbold.png"

import Raleway from "../assets/fonts/raleway.fnt"
import RalewaySheet from "../assets/fonts/raleway.png"

import Quicksand from "../assets/fonts/quicksand.fnt"
import QuicksandSheet from "../assets/fonts/quicksand.png"

import QuicksandMedium from "../assets/fonts/quicksandmedium.fnt"
import QuicksandMediumSheet from "../assets/fonts/quicksandmedium.png"

class TextPlane extends Component {
    render() {
        return(
            <Entity
                primitive="a-plane"

                width={this.props.width}
                height={this.props.height}

                color={this.props.planeColor}

                material={{
                    shader: "flat",
                }}
            >

                <Entity
                    primitive="a-text"

                    position={{x: 0, y:0, z:0.1}}

                    text={{
                        value: this.props.text,

                        // font: Helvetica,
                        // fontImage: HelveticaSheet,

                        // font: OpenSans,
                        // fontImage: OpenSansSheet,

                        // font: OpenSansBold,
                        // fontImage: OpenSansBoldSheet,

                        // font: Raleway,
                        // fontImage: RalewaySheet,

                        font: Quicksand,
                        fontImage: QuicksandSheet,

                        // font: QuicksandMedium,
                        // fontImage: QuicksandMediumSheet,


                        // font: "roboto",

                        wrapCount: this.props.wrapCount,
                        color: this.props.textColor,

                        height: this.props.width,
                        width: this.props.height,

                        align: "center"
                    }}
                />

            </Entity>
        );
    }
}

TextPlane.defaultProps = {
    width: 3,
    height: 3,

    // planeColor: "#FAFAFA",
    planeColor: "#FFF",
    textColor: "black",

    wrapCount: 10,
}

export default TextPlane


// WEBPACK FOOTER //
// ./src/components/TextPlane.js